import { makeActionCreator } from '../../../utilities'
import { PCRConstants } from './pcr.constants'

export const throwPcrException = makeActionCreator(PCRConstants.THROW_PCR_EXCEPTION, 'exception')
// TODO remove this from all tests when we fix the unit tests
export const createPcr = makeActionCreator(PCRConstants.CREATE_PCR)
export const crudPcrException = makeActionCreator(PCRConstants.CRUD_PCR_EXCEPTION, 'exception')
export const resetPcrError = makeActionCreator(PCRConstants.RESET_PCR_ERROR)
export const logErrorAction = makeActionCreator(PCRConstants.LOG_ERROR_ACTION, 'error')
